export default __webpack_public_path__ + "static/media/M2 - Bear Treat.0ab8d48f.png";